import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

const resendClientInvite = async (email: string) => {
  const response = await authAPI.get(`/activation/resend/${encodeURIComponent(email)}`)
  return response.data
}

export const useResendClientInvite = () =>
  useMutation({
    mutationFn: (email: string) => resendClientInvite(email),
  })
